/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Field, FormikProvider, useFormik } from 'formik';
import { AxiosError } from 'axios';
import FieldInputText from '../../common/FieldInputText';
import { useDispatch, useSelector } from 'react-redux';
import { ResetPassword, VerifyPasswordLink } from '../../../redux/features/auth/authActions';
import { errorMessage } from '../../../utlis/common';
import { INVALID_CHANGE_PASSWORD_LINK } from '../../../utlis/messages';
import SubmitButton from '../../common/SubmitButton';

export function ChangePassword() {
    const [showPassword, setShowPassword] = useState(true);
    const [showConfirmPassword, setShowConfirmPassword] = useState(true);
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id') || '';
    const otp = searchParams.get('otp') || null;

    const dispatch: any = useDispatch()
    const navigate = useNavigate();
    const authState = useSelector((state: any) => state.auth);
    const resetPasswordSlice = useSelector((state: any) => state.resetPasswordSlice)


    useEffect(() => {
        if (id && otp) { dispatch(VerifyPasswordLink({ id, otp, navigate })) }
        else {
            errorMessage(INVALID_CHANGE_PASSWORD_LINK)
            navigate('/auth/forgot-password')
        }
    }, [id]);


    const initialValues = {
        password: '',
        confirmPassword: '',
    };

    const changePasswordSchema = Yup.object().shape({
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password should be at least 8 characters')
            .matches(/[A-Z]/, 'One uppercase letter is required')
            .matches(/[a-z]/, 'One lowercase letter is required')
            .matches(/[0-9]/, 'One number is required')
            .matches(/[@#%!-]/, 'One special character is required'),
        confirmPassword: Yup.string()
            .required('Please confirm your password')
            .oneOf([Yup.ref('password')], 'Passwords must match'),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: changePasswordSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            values['email'] = authState.email;
            dispatch(ResetPassword({ values, navigate }))
        },
    });

    return (
        <FormikProvider value={formik}>
            <form
                className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
                noValidate
                id="kt_login_password_reset_form"
                onSubmit={formik.handleSubmit}
            >
                <div className="text-center mb-10">
                    <h1 className="text-dark fw-bolder mb-3">Imposta la tua nuova password</h1>
                    <div className="text-gray-500 fw-semibold fs-6">
                        Crea una password con una combinazione di lettere, numeri e simboli (@,#,%,!)
                    </div>
                </div>

                <div className="fv-row mb-3">
                    <div className="position-relative">
                        <Field
                            name="password"
                            validate={changePasswordSchema}
                            label="Password"
                            type={showPassword ? 'password' : 'text'}
                            required={true}
                            component={FieldInputText}
                            placeholder="Password"
                        />

                        <i
                            className={showPassword ? 'bi bi-eye-slash-fill eyeIcon' : 'bi bi-eye-fill eyeIcon'}
                            onClick={() => setShowPassword(!showPassword)}
                        ></i>
                    </div>

                </div>

                <div className="fv-row mb-3">
                    <div className="position-relative">
                        <Field
                            name="confirmPassword"
                            validate={showConfirmPassword}
                            label="Conferma Password"
                            type={showConfirmPassword ? 'password' : 'text'}
                            required={true}
                            component={FieldInputText}
                            placeholder="Conferma Password"
                        />

                        <i
                            className={
                                showConfirmPassword ? 'bi bi-eye-slash-fill eyeIcon' : 'bi bi-eye-fill eyeIcon'
                            }
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        ></i>
                    </div>

                </div>

                <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                    <SubmitButton title="Invia" type='submit' loading={resetPasswordSlice?.loading} />
                    <Link to="/auth/login">
                        <button type="button" className="btn btn-light">
                            Annulla
                        </button>
                    </Link>
                </div>
            </form>
        </FormikProvider>
    );
}
